<div class="chart-responsive">
  <div class="chart-wrapper">
    @if (chartData(); as data) {
      <canvas
        class="chart-canvas"
        baseChart
        [options]="chartOptions()"
        [datasets]="data.datasets"
        [labels]="data.labels"
        role="img"
        width="500"
        height="400"
      >
      </canvas>
    }
  </div>
</div>
